import { createRouter,createWebHistory} from 'vue-router' // createWebHashHistory
//import common from '../../common/common.js'
//common.clearLogin();

const routes = [
	{ path: "/logout", meta: { title: "注 销" }, component: () => import("../views/logout/index"), hidden: true,children:[] },
	{ path: "/login", meta: { title: "登 录" }, component: () => import("../views/login/index"), hidden: true,children:[] },
	{
	 path: "/:catchAll(.*)",
	 meta: { title: "没有此页面" },
	 component: () => import("../views/error/404")
	},
]
// 这里不要用VueRouter.来使用方法 直接用导入的
const router = createRouter({
    // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
    //history: createWebHashHistory(),
	history: createWebHistory("/"),//去掉#
    routes, // `routes: routes` 的缩写
});

export default router
